<template>
  <router-view />
</template>

<script>
export default {
  name: "Tarrifs"
}
</script>
